// SPDX-License-Identifier: AGPL-3.0-or-later

import {ConfirmModal} from '@app/features/app/components/dialogs/ConfirmModal';
import {Logger} from '@app/features/platform/utils/AppLogger';
import * as ModalCommands from '@app/features/ui/commands/ModalCommands';
import {modal} from '@app/features/ui/commands/ModalCommands';
import Notification from '@app/features/ui/state/Notification';
import type {I18n} from '@lingui/core';
import {msg} from '@lingui/core/macro';
import {Trans} from '@lingui/react/macro';

const logger = new Logger('Notification');
export function permissionDenied(i18n: I18n, suppressModal = false): void {
	logger.debug('Notification permission denied');
	Notification.handleNotificationPermissionDenied();
	if (suppressModal) return;
	ModalCommands.push(
		modal(() => (
			<ConfirmModal
				title={i18n._(msg`Notifications Blocked`)}
				description={
					<p>
						<Trans>
							Desktop notifications have been blocked. You can enable them later in your browser settings or in User
							Settings &gt; Notifications.
						</Trans>
					</p>
				}
				primaryText={i18n._(msg`OK`)}
				primaryVariant="primary"
				secondaryText={false}
				onPrimary={() => {}}
			/>
		)),
	);
}
export function permissionGranted(): void {
	logger.debug('Notification permission granted');
	Notification.handleNotificationPermissionGranted();
}
export function toggleUnreadMessageBadge(enabled: boolean): void {
	Notification.handleNotificationSoundToggle(enabled);
}
